import escapeRegExp from "lodash.escaperegexp";

export const createSearchRegExp = (searchQuery?: string) =>
  new RegExp(escapeRegExp(searchQuery), "i");
